// Client-cancelled requests (navigating away, refreshing, closing a tab mid-SSR)
// surface as low-level "aborted" / ECONNRESET errors. They are a normal part of
// browsing, not application failures, so they must never be reported as fatal
// runtime errors or turned into an error page.

const ABORT_CODES = new Set([
  "ABORT_ERR",
  "ECONNRESET",
  "ECONNABORTED",
  "EPIPE",
  "ERR_STREAM_PREMATURE_CLOSE",
]);

export function isRequestAbortError(error: unknown): boolean {
  if (!error) return false;

  if (typeof DOMException !== "undefined" && error instanceof DOMException) {
    if (error.name === "AbortError") return true;
  }

  const e = error as { name?: unknown; code?: unknown; message?: unknown };

  if (typeof e.name === "string" && (e.name === "AbortError" || e.name === "TimeoutError")) {
    return e.name === "AbortError";
  }
  if (typeof e.code === "string" && ABORT_CODES.has(e.code)) return true;

  if (typeof e.message === "string") {
    const m = e.message.toLowerCase();
    if (
      m === "aborted" ||
      m.includes("request aborted") ||
      m.includes("the operation was aborted") ||
      m.includes("premature close") ||
      m.includes("socket hang up")
    ) {
      return true;
    }
  }

  return false;
}
